export const CornholeIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className}>
    <circle cx="32" cy="32" r="24" stroke="currentColor" strokeWidth="5" />
    <circle cx="32" cy="32" r="14" stroke="currentColor" strokeWidth="5" />
    <circle cx="32" cy="32" r="5" fill="currentColor" />
  </svg>
);
